<template lang="pug">
  div
    ReportSummary(
      v-bind:summary="report.summary"
      v-bind:resources="report.resources"
      v-bind:simulations="simulations"
      v-bind:types="types"
    )

    ImageResourcesTable(
      v-bind:s3KeyBase="report.page.s3KeyBase"
      v-bind:summary="report.summary"
      v-bind:resources="simulatedResources"
      v-bind:simulations="simulations"
      v-bind:tableTitle="translate('simulatedTable')"
    )

    .row
      .col-md-6
        ImageResourcesTable(
          v-bind:s3KeyBase="report.page.s3KeyBase"
          v-bind:summary="report.summary"
          v-bind:resources="lightfileResoruces"
          v-bind:simulations="['orig']"
          v-bind:tableTitle="translate('lightfileTable')"
        )
      .col-md-6
        ImageResourcesTable(
          v-bind:s3KeyBase="report.page.s3KeyBase"
          v-bind:summary="report.summary"
          v-bind:resources="lightfileNeverResoruces"
          v-bind:simulations="['orig']"
          v-bind:tableTitle="translate('lightfileNeverTable')"
        )

</template>

<script>
import BaseReport from '@/components/reports/BaseReport.vue'

export default {
  mixins: [BaseReport],
  computed: {
    simulations: () => ['orig', 'low'],
    types: () => ['gif', 'webp', 'lightfile', 'jpg', 'png'],
    simulatedResources: function() {
      return this.report.resources.filter(r => r.simulated)
    },
    lightfileResoruces: function() {
      return this.report.resources.filter(r => r.lightfile)
    },
    lightfileNeverResoruces: function() {
      return this.report.resources.filter(r => r.isImage && r.ext != 'jpg' && r.ext != 'png')
    },
  },
}
</script>